import React from "react";
import Loader from "../../../organisms/loader/Loader";
import { formatTime } from "../../utils/tools";

const STATUS = {
  completed: { cls: "cp", label: "Completed" },
  "in progress": { cls: "ip", label: "In progress" },
  "not started": { cls: "ns", label: "Not started" },
};

function Section({ title, section, onView }) {
  const rows = section?.data || [];
  const meta = `Total spend time: ${formatTime(section?.total_study_time || 0)}`;

  return (
    <div className="lp-actsec">
      <div className="lp-actsec__head">
        <h4>{title}</h4>
        <span className="lp-actsec__tot">{meta}</span>
      </div>
      {rows.length === 0 ? (
        <div className="lp-actsec__empty">No {title.toLowerCase()} yet.</div>
      ) : (
        <table className="lp-mt">
          <thead>
            <tr>
              <th>Material</th>
              <th>Status</th>
              <th>Time spent</th>
              <th className="lp-mt__right">Details</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => {
              const st = STATUS[r.status] || STATUS["not started"];
              return (
                <tr key={r.learning_material_id}>
                  <td>
                    <span
                      className="lp-mi"
                      style={{ background: r.favicon ? "transparent" : "#0FA3B8" }}
                    >
                      {r.favicon ? <img src={r.favicon} alt="" /> : null}
                    </span>
                    {r.material_name}
                  </td>
                  <td>
                    <span className={`lp-mp lp-mp--${st.cls}`}><span className="lp-mp__d" />{st.label}</span>
                  </td>
                  <td>{formatTime(r.time_spent_minutes || 0)}</td>
                  <td className="lp-mt__right">
                    <button
                      type="button"
                      className="lp-viewb"
                      onClick={() => onView?.({
                        learning_material_id: r.learning_material_id,
                        material_name: r.material_name,
                        material_type: r.material_type,
                      })}
                    >
                      View
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}

function ActivityTab({ data, loading, onView }) {
  if (loading) return <div className="lp-pad"><Loader /></div>;

  const hasAny = (data?.paths?.data?.length || 0)
    + (data?.walkthrough?.data?.length || 0)
    + (data?.docs?.data?.length || 0) > 0;

  if (!hasAny) {
    return <div className="lp-pad"><div className="lp-empty-inline">No learning activity recorded yet.</div></div>;
  }

  return (
    <div className="lp-pad">
      <Section title="Paths" section={data?.paths} onView={onView} />
      <Section title="Walkthroughs" section={data?.walkthrough} onView={onView} />
      <Section title="Docs" section={data?.docs} onView={onView} />
    </div>
  );
}

export default ActivityTab;
